<template>
  <div>
    <h2 class="window-header subtitle has-background-danger has-text-white">
      {{ title }}
    </h2>
    <div action="/action_page.php">
      <label> {{ message }} </label>
      <span
        ><b>
          {{ selectedItem.firstName }} {{ selectedItem.lastName }} </b
        >?
      </span>
      <br /><br /><br /><br /><br />
      <button
        class="button is-danger is-light is-rounded"
        @click="deleteButtonClicked"
      >
        OBRIŠI
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteItem",

  props: {
    title: String,
    message: String,
    selectedItem: Object,
  },

  methods: {
    deleteButtonClicked() {
      this.$emit("deleteButtonClicked");
    },
  },
};
</script>